__turbopack_context__.v({
  "className": "sourcesanspro_ea5625ea-module__eIhETG__className",
});
